import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-surface px-5 py-20 sm:py-28" data-id="element-213" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-4xl" data-id="element-214" data-mp="3ksgw62jxe7aa">
        <div className="text-center" data-id="element-215" data-mp="3fyvykbm8vfbm">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-success" data-id="element-216" data-mp="3fxumq4xemosu">
            Avis vérifiés
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-foreground sm:text-[2.6rem]" data-id="element-217" data-mp="36yzcmhr8ouk9">
            Ce que disent vos{' '}
            <span className="italic text-emphasis" data-id="element-218" data-mp="31yl8vbwo86s1">collègues</span>
          </h2>
        </div>

        <div className="mx-auto mt-10 grid max-w-3xl gap-5 sm:grid-cols-2" data-id="element-219" data-mp="2x11r420rlbvc">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-background p-6" data-id="element-220" data-mp="2s431nws1pt3h">
              <div className="text-sm text-rating" aria-label="5 étoiles sur 5" data-id="element-221" data-mp="qa3qdbexbbqs">
                <span aria-hidden="true" data-id="element-222" data-mp="h5f0hpouu32s">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-foreground/85" data-id="element-223" data-mp="h8axnbsvonq6">
                &laquo;&nbsp;{item.quote}&nbsp;&raquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-224" data-mp="7a4zn5a701ql">
                <p className="text-xs font-bold text-foreground" data-id="element-225" data-mp="c7wotrjgd9r3">{item.name}</p>
                <p className="text-xs text-foreground/45" data-id="element-226" data-mp="zvweeo512u43">{item.role}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}